import { Col, ColType, Crud, CrudApi, CrudAction } from "../../comp/crud";
import { ApiClient, ApiConfig, ApiResp } from "../../api/ApiClient";
import "../clientConfig/index.scss";
import { TextCell } from "../../comp/cell";
import {
  Toast,
  Modal,
  Row,
  Col as RowCol,
  Tag,
  Divider,
  Select,
  JsonViewer,
  Button,
  List,
  Input,
  Form,
} from "@douyinfe/semi-ui";
import {IconGithubLogo, IconComment, IconSearch, IconModalStroked} from "@douyinfe/semi-icons";
import React, { useState, useRef, useEffect } from "react";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

let apiClient = ApiClient.getDefault();
let cols: Col[] = [
  {
    name: "分类",
    key: "category",
    type: ColType.STRING,
    showInFilter: true,
  },
  {
    name: "名称",
    key: "name",
    type: ColType.STRING,
    showInFilter: true,
  },
  {
    name: "Code",
    key: "code",
    type: ColType.STRING,
    showInFilter: true,
  },
  {
    name: "客户端",
    key: "client",
    type: ColType.STRING,
    showInFilter: false,
  },
  {
    name: "值描述",
    key: "valueDesc",
    type: ColType.TEXT,
    render: (a) => <TextCell text={a} width={500} />,
  },
  {
    name: "值",
    key: "value",
    type: ColType.TEXT,
    render: (a) => <TextCell text={a} width={500} />,
  },
];
export default function ApiConfigView() {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [invokeApiFormApi, setInvokeApiFormApi] = useState<any>();
  const [invokeApiing, setInvokeApiing] = useState(false);
  const [showInvokeApiModal, setShowInvokeApiModal] = useState(false);
  const [saving, setSaving] = useState(false);

  const [list, setList] = useState([] as ApiConfig[]);
  const [models, setModels] = useState([] as any[]);
  const [apiConfig, setApiConfig] = useState({} as ApiConfig);
  const [currSystem, setCurrSystem] = useState("ggd");
  const [currModel, setCurrModel] = useState("" as string);
  const [reqParams, setReqParams] = useState("" as string);
  const [respResult, setRespResult] = useState("" as string);
  const systems = [
    { value: "ggd", label: "ggd" },
    { value: "demeter", label: "demeter" },
  ];
  
  const systemChange = (system: any) => {
    setInitFilterValues({
      client: system,
    });
    setInitParams({
      client: system,
    });
    setCurrSystem(system);
    fetchListCategory(system);
    crudApi?.executeQuery({
      client: system,
    });
  };
  const modelChange = (model: any) => {
    setCurrModel(model);
    
  };

  const onSearch = (string: any) => {
    let newList;
    if (string) {
      newList = list.filter(
        (item) => item.code.includes(string) || item.name.includes(string)
      );
    } else {
      newList = list;
    }
    setList(newList);
  };

  useEffect(() => {
    fetchListCategory("ggd");
    getApiConfigByCode("ggd", "API_ENV_CONFIG")
  }, []);

  const getApiConfigByCode = async (client:string, code:string) => {
    try {
      apiClient
        .request<string>("/apiConfig/getByCode", "GET", {
          client: client,
          code: code,
        })
        .then((response) => {
          //转为json对象
          console.log(response.data);
          let models = JSON.parse(response.data);
          // const models = [
          //   { value: "dev", label: "开发" },
          //   { value: "test", label: "测试" },
          // ];
          setModels(models);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchListCategory = async (system:string) => {
    try {
      apiClient
        .request<ApiConfig[]>("/apiConfig/categorySelect", "GET", {
          client: system,
        })
        .then((response) => {
          setList(response.data);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  //处理
  const handleCategoryQuery = async (category: string) => {
    if (!category.trim()) return;
    crudApi?.executeQuery({
      client: currSystem,
      category: category,
    });
  };

  const [initFilterValues, setInitFilterValues] = useState({
    client: currSystem,
  });

  const [initParams, setInitParams] = useState( {
    client: currSystem,
  });

  const handleInvokeApiClick = async () => {
    if(!currModel.startsWith("http")){
      Toast.info("请选择环境");
      return;
    }
    Modal.confirm({
      title: "是否确认执行?",
      content: "",
      onOk: async () => {
        setSaving(true);
        try {
          console.log("currModel:", currModel);
          let name = invokeApiFormApi?.getValue("name");
          let code = invokeApiFormApi?.getValue("code");
          
          code = currModel +"/api/mis"+ code;
          let value = '';//reqJsonviewerRef.current?.getValue();
          console.log("value", value);
          let ret = await apiClient.request<string>("/apiConfig/invokeApi", "POST", undefined, {
            name: name,
            code: code,
            value: value,
          });
          setRespResult(ret.data);
          Toast.info("执行成功");
          setSaving(false);
        } catch (e) {
          setSaving(false);
        }
      },
    });
  };

  const handleSaveClick = async () => {
    if (saving) {
      return;
    }
    Modal.confirm({
      title: "是否确认保存?",
      content: "",
      onOk: async () => {
        setSaving(true);
        try {
          let id = apiConfig.id;
          let name = invokeApiFormApi?.getValue("name");
          let code = invokeApiFormApi?.getValue("code");
          let value = apiConfig.value;
          console.log("value", value);
          let valueDesc = invokeApiFormApi?.getValue("valueDesc");
          await apiClient.request("/apiConfig", "PUT", undefined, {
            id: id,
            name: name,
            code: code,
            value: value,
            valueDesc: valueDesc,
          });
          Toast.info("保存成功");
          setSaving(false);
        } catch (e) {
          setSaving(false);
        }
      },
    });
  };
  const reqJsonviewerRef = useRef<JsonViewer>();
  let reqFormatJsonComponent = (jsonviewerRef: any) => {
    return (
      <div>
        <Button onClick={() => console.log(jsonviewerRef?.current.format())}>
          格式化
        </Button>
        <div style={{ marginBottom: 16, marginTop: 16 }}>
          <JsonViewer
            ref={jsonviewerRef}
            height={500}
            width={900}
            value={reqParams}
            options={{
              formatOptions: { tabSize: 4, insertSpaces: true, eol: "\n" },
            }}
          />
        </div>
      </div>
    );
  };

  const respJsonviewerRef = useRef();
  let respFormatJsonComponent = (jsonviewerRef: any) => {
    return (
      <div>
        <Button onClick={() => console.log(jsonviewerRef?.current.format())}>
          格式化
        </Button>
        <div style={{ marginBottom: 16, marginTop: 16 }}>
          <JsonViewer
            ref={jsonviewerRef}
            height={500}
            width={900}
            value={respResult}
            options={{
              formatOptions: { tabSize: 4, insertSpaces: true, eol: "\n" },
            }}
          />
        </div>
      </div>
    );
  };

  const actions: CrudAction[] = [];
  const invokeApiAction: CrudAction = {
    name: "执行",
    action: (row: any) => {
      setShowInvokeApiModal(true);
      setApiConfig(row);
      setReqParams(row.value);
    },
  };
  actions.push(invokeApiAction);

  const copyApiAction: CrudAction = {
    name: "复制接口",
    action: (row: any) => {
      try {
       apiClient.request("/apiConfig/copy", "PUT", undefined, {
          id: row.id,
        });
        crudApi?.refresh();
        Toast.info("复制成功");
      } catch (e) {
        Toast.info("复制失败");
      }
    },
  };
  actions.push(copyApiAction);

  return (
    <>
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        title="执行接口"
        visible={showInvokeApiModal}
        confirmLoading={invokeApiing}
        fullScreen={true}
        onCancel={() => setShowInvokeApiModal(false)}
      >
        <Form<ApiConfig>
          initValues={apiConfig}
          getFormApi={(formApi) => setInvokeApiFormApi(formApi)}
        >
          <Row gutter={[16, 16]}>
            <RowCol span={24}>
              <Tag
                style={{ marginBottom: "15px" }}
                color="light-blue"
                prefixIcon={<IconGithubLogo />}
                size="large"
                shape="circle"
              >
                切换环境：
              </Tag>
              <Select
                style={{ width: "250px", margin: "10px" }}
                onChange={modelChange}
                
              >
                {models.map((pro) => (
                  <Select.Option value={pro.value} key={pro.label}>
                    {pro.label}-{pro.value}
                  </Select.Option>
                ))}
              </Select>
            </RowCol>
            </Row>
            <Row gutter={[16, 16]}>
            
            <RowCol span={6}>
              <Form.Input
                rules={[{ required: true, message: "请填写" }]}
                style={{ width: "100%" }}
                multiple
                field="code"
                label="请求url"
              />
            </RowCol>
            <RowCol span={6}>
              <Form.Input
                rules={[{ required: true, message: "请填写" }]}
                style={{ width: "100%" }}
                multiple
                field="name"
                label="接口名"
              />
            </RowCol>
            <RowCol span={12}>
              <Form.TextArea
                rules={[{ required: true, message: "请填写" }]}
                style={{ width: "100%" }}
                field="valueDesc"
                label="说明"
              />
            </RowCol>
          </Row>

          <Row gutter={[16, 16]}>
            <RowCol span={12}>
              {reqFormatJsonComponent(reqJsonviewerRef)}
            </RowCol>
            <RowCol span={12}>
              {respFormatJsonComponent(respJsonviewerRef)}
            </RowCol>
          </Row>
          <Row gutter={[16, 16]}>
            <RowCol span={12}>
            <Button type="primary" theme="solid" block onClick={handleInvokeApiClick}>执行</Button>
            </RowCol>
            <RowCol span={12}>
            <Button type="secondary" theme="solid" block onClick={handleSaveClick}>保存</Button>
            </RowCol>
          </Row>
          
          
        </Form>
      </Modal>
      <Row gutter={[0, 16]}>
        <RowCol span={24}>
          <Tag
            style={{ marginBottom: "15px" }}
            color="light-blue"
            prefixIcon={<IconGithubLogo />}
            size="large"
            shape="circle"
          >
            选择系统：
          </Tag>
          <Select
            style={{ width: "250px", margin: "10px" }}
            onChange={systemChange}
            defaultValue={systems[0].value}
          >
            {systems.map((pro) => (
              <Select.Option value={pro.value} key={pro.value}>
                {pro.label}
              </Select.Option>
            ))}
          </Select>
        </RowCol>
      </Row>
      <Divider />
      <Row>
        <RowCol span={4}>
          <div style={{ height: "240vh", margin: 5, overflowY: "auto" }}>
            <List
              className="component-list-demo-booklist"
              dataSource={list}
              split={false}
              header={
                <Input
                  onCompositionEnd={(v: any) => onSearch(v.target.value)}
                  onChange={(v) => (!v ? onSearch(v) : null)}
                  placeholder="搜索"
                  prefix={<IconSearch />}
                />
              }
              size="small"
              style={{
                flexBasis: "100%",
                flexShrink: 0,
                borderBottom: "1px solid var(--semi-color-border)",
              }}
              renderItem={(item) => (
                <List.Item className="list-item">
                  <Button
                    icon={<IconComment />}
                    type="secondary"
                    onClick={() => handleCategoryQuery(item.category)}
                  >
                    {item.category}
                  </Button>
                </List.Item>
              )}
            />
          </div>
        </RowCol>
        <RowCol span={20}>
          <Crud
            getCrudApi={(crudApi) => {
              setCrudApi(crudApi);
            }}
            canUpdate={true}
            canCreate={true}
            initFilterValues={initFilterValues}
            initParams={initParams}
            getRowActions={(row) => {
              return actions;
            }}
            name="接口中心"
            entityKey="apiConfig"
            pageSize={50}
            cols={cols}
          />
        </RowCol>
      </Row>
     
    </>
  );
}
